var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchoolThin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    stroke: "#000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.679 8.983L12.03 3.087l10.351 5.896-10.351 5.896L1.679 8.983z",
    strokeWidth: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.376 11.194v5.895l6.654 3.685 6.654-3.685v-5.895M22.381 17.09V8.982",
    strokeWidth: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.03 14.879v5.895",
    strokeWidth: 0.4095
  }))));
}
export default SvgSchoolThin;